(function () {
  'use strict';

  angular
    .module('cabinFlightIssues')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('cabinFlightIssues', {
        url: '/cabin-flight-issues',
        views : {
        	'cabinFlightIssuesView' : {
        		templateUrl: 'cabin-flight-issues/views/cabin-flight-issues.tpl.html',
                controller: 'CabinFlightIssuesCtrl',
                controllerAs: 'cabinFlightIssues'
        	}
        }
      });
  }
}());
